import { render, staticRenderFns } from "./DealersTransporterDetail.vue?vue&type=template&id=4f088341&scoped=true"
import script from "./DealersTransporterDetail.vue?vue&type=script&lang=ts"
export * from "./DealersTransporterDetail.vue?vue&type=script&lang=ts"
import style0 from "./DealersTransporterDetail.vue?vue&type=style&index=0&id=4f088341&lang=scss"
import style1 from "./DealersTransporterDetail.vue?vue&type=style&index=1&id=4f088341&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f088341",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f088341')) {
      api.createRecord('4f088341', component.options)
    } else {
      api.reload('4f088341', component.options)
    }
    module.hot.accept("./DealersTransporterDetail.vue?vue&type=template&id=4f088341&scoped=true", function () {
      api.rerender('4f088341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-transporters/components/DealersTransporterDetail.vue"
export default component.exports